/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Start_2_TitleInputs */

const en_mk_start_2_title = /** @type {(inputs: Mk_Start_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divisions, channels and agents set themselves up`)
};

const id_mk_start_2_title = /** @type {(inputs: Mk_Start_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divisi, channel, dan agen terpasang sendiri`)
};

/**
* | output |
* | --- |
* | "Divisions, channels and agents set themselves up" |
*
* @param {Mk_Start_2_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_start_2_title = /** @type {((inputs?: Mk_Start_2_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Start_2_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_start_2_title(inputs)
	return en_mk_start_2_title(inputs)
});